$(function () {
    $("#standard-e3").click(function () {
      if ($(".standard-e3").is(":visible")){
        if ($(".standard-e5").is(":visible")){
          if($("#standard").prop("disabled")){
            $("#standard-e5").prop("checked") && $("#standard-e5").prop("disabled", true);
          }
          $(".column-standard.column-header").attr('colspan', 1);
          $(".standard-e3").hide();
        } else {
          $("#standard").prop("checked", false);
          $(".column-standard.column-header").attr('colspan', 1);
          $(".column-standard").hide();
        }
      } else {
        if ($(".standard-e5").is(":visible")){
          if($("#standard").prop("disabled")){
            $("#standard-e5").prop("checked") && $("#standard-e5").prop("disabled", false);
          }
          $(".column-standard.column-header").attr('colspan', 2);
          $(".standard-e3").show();
        } else {
          $("#standard").prop("checked", true);
          $(".column-standard.column-header").show();
          $(".column-standard.column-header").attr('colspan', 1);
          $(".standard-e3").show();
        }
      }
    });
    $("#standard-e5").click(function () {
      if ($(".standard-e5").is(":visible")){
        if ($(".standard-e3").is(":visible")){
          if($("#standard").prop("disabled")){
            $("#standard-e3").prop("checked") && $("#standard-e3").prop("disabled", true);
          }
          $(".column-standard.column-header").attr('colspan', 1);
          $(".standard-e5").hide();
        } else {
          $("#standard").prop("checked", false);
          $(".column-standard.column-header").attr('colspan', 1);
          $(".column-standard").hide();
        }
      } else {
        if ($(".standard-e3").is(":visible")){
          if($("#standard").prop("disabled")){
            $("#standard-e3").prop("checked") && $("#standard-e3").prop("disabled", false);
          }
          $(".column-standard.column-header").attr('colspan', 2);
          $(".standard-e5").show();
        } else {
          $("#standard").prop("checked", true);
          $(".column-standard.column-header").show();
          $(".column-standard.column-header").attr('colspan', 1);
          $(".standard-e5").show();
        }
      }
    });
$("#business-basic").click(function () {
      if ($(".business-basic").is(":visible")){
        if ($(".business-standard").is(":visible")){
          if ($(".business-premium").is(":visible")){
            $(".column-business.column-header").attr('colspan', 2);
            $(".business-basic").hide();
          } else {
            if($("#business").prop("disabled")){
              $("#business-standard").prop("disabled", true);
            }
            $(".column-business.column-header").attr('colspan', 1);
            $(".business-basic").hide();
          }
        } else {
          if ($(".business-premium").is(":visible")){
            if($("#business").prop("disabled")){
              $("#business-premium").prop("disabled", true);
            }
            $(".column-business.column-header").attr('colspan', 1);
            $(".business-basic").hide();
          } else {
            $("#business").prop("checked", false);
            $(".column-business.column-header").attr('colspan', 1);
            $(".column-business").hide();
          }
        }
      } else {
        if ($(".business-standard").is(":visible")){
          if ($(".business-premium").is(":visible")){
            $(".column-business.column-header").attr('colspan', 3);
            $(".business-basic").show();
          } else {
            $(".column-business.column-header").attr('colspan', 2);
            $(".business-basic").show();
          }
        } else {
          if ($(".business-premium").is(":visible")){
            $(".column-business.column-header").attr('colspan', 2);
            $(".business-basic").show();
          } else {
            $("#business").prop("checked", true);
            $(".column-business.column-header").show();
            $(".column-business.column-header").attr('colspan', 1);
            $(".business-basic").show();
          }
        }
      }
    });
    $("#business-standard").click(function () {
      if ($(".business-standard").is(":visible")){
        if ($(".business-basic").is(":visible")){
          if ($(".business-premium").is(":visible")){
            $(".column-business.column-header").attr('colspan', 2);
            $(".business-standard").hide();
          } else {
            if($("#business").prop("disabled")){
              $("#business-basic").prop("disabled", true);
            }
            $(".column-business.column-header").attr('colspan', 1);
            $(".business-standard").hide();
          }
        } else {
          if ($(".business-premium").is(":visible")){
            if($("#business").prop("disabled")){
              $("#business-premium").prop("disabled", true);
            }
            $(".column-business.column-header").attr('colspan', 1);
            $(".business-standard").hide();
          } else {
            $("#business").prop("checked", false);
            $(".column-business.column-header").attr('colspan', 1);
            $(".column-business").hide();
          }
        }
      } else {
        if ($(".business-basic").is(":visible")){
          if ($(".business-premium").is(":visible")){
            $(".column-business.column-header").attr('colspan', 3);
            $(".business-standard").show();
          } else {
            $(".column-business.column-header").attr('colspan', 2);
            $(".business-standard").show();
          }
        } else {
          if ($(".business-premium").is(":visible")){
            $(".column-business.column-header").attr('colspan', 2);
            $(".business-standard").show();
          } else {
            $("#business").prop("checked", true);
            $(".column-business.column-header").show();
            $(".column-business.column-header").attr('colspan', 1);
            $(".business-standard").show();
          }
        }
      }
    });
    $("#business-premium").click(function () {
      if ($(".business-premium").is(":visible")){
        if ($(".business-standard").is(":visible")){
          if ($(".business-basic").is(":visible")){
            $(".column-business.column-header").attr('colspan', 2);
            $(".business-premium").hide();
          } else {
            if($("#business").prop("disabled")){
              $("#business-standard").prop("disabled", true);
            }
            $(".column-business.column-header").attr('colspan', 1);
            $(".business-premium").hide();
          }
        } else {
          if ($(".business-basic").is(":visible")){
            if($("#business").prop("disabled")){
              $("#business-basic").prop("disabled", true);
            }
            $(".column-business.column-header").attr('colspan', 1);
            $(".business-premium").hide();
          } else {
            $("#business").prop("checked", false);
            $(".column-business.column-header").attr('colspan', 1);
            $(".column-business").hide();
          }
        }
      } else {
        if ($(".business-standard").is(":visible")){
          if ($(".business-basic").is(":visible")){
            $(".column-business.column-header").attr('colspan', 3);
            $(".business-premium").show();
          } else {
            $(".column-business.column-header").attr('colspan', 2);
            $(".business-premium").show();
          }
        } else {
          if ($(".business-basic").is(":visible")){
            $(".column-business.column-header").attr('colspan', 2);
            $(".business-premium").show();
          } else {
            $("#business").prop("checked", true);
            $(".column-business.column-header").show();
            $(".column-business.column-header").attr('colspan', 1);
            $(".business-premium").show();
          }
        }
      }
    });
    $("#enterprise-e3").click(function () {
      if ($(".enterprise-e3").is(":visible")){
        if ($(".enterprise-e5").is(":visible")){
          if($("#enterprise").prop("disabled")){
            $("#enterprise-e5").prop("checked") && $("#enterprise-e5").prop("disabled", true);
          }
          $(".column-enterprise.column-header").attr('colspan', 1);
          $(".enterprise-e3").hide();
        } else {
          $("#enterprise").prop("checked", false);
          $(".column-enterprise.column-header").attr('colspan', 1);
          $(".column-enterprise").hide();
        }
      } else {
        if ($(".enterprise-e5").is(":visible")){
          if($("#enterprise").prop("disabled")){
            $("#enterprise-e5").prop("checked") && $("#enterprise-e5").prop("disabled", false);
          }
          $(".column-enterprise.column-header").attr('colspan', 2);
          $(".enterprise-e3").show();
        } else {
          $("#enterprise").prop("checked", true);
          $(".column-enterprise.column-header").show();
          $(".column-enterprise.column-header").attr('colspan', 1);
          $(".enterprise-e3").show();
        }
      }
    });
    $("#enterprise-e5").click(function () {
      if ($(".enterprise-e5").is(":visible")){
        if ($(".enterprise-e3").is(":visible")){
          if($("#enterprise").prop("disabled")){
            $("#enterprise-e3").prop("checked") && $("#enterprise-e3").prop("disabled", true);
          }
          $(".column-enterprise.column-header").attr('colspan', 1);
          $(".enterprise-e5").hide();
        } else {
          $("#enterprise").prop("checked", false);
          $(".column-enterprise.column-header").attr('colspan', 1);
          $(".column-enterprise").hide();
        }
      } else {
        if ($(".enterprise-e3").is(":visible")){
          if($("#enterprise").prop("disabled")){
            $("#enterprise-e3").prop("checked") && $("#enterprise-e3").prop("disabled", false);
          }
          $(".column-enterprise.column-header").attr('colspan', 2);
          $(".enterprise-e5").show();
        } else {
          $("#enterprise").prop("checked", true);
          $(".column-enterprise.column-header").show();
          $(".column-enterprise.column-header").attr('colspan', 1);
          $(".enterprise-e5").show();
        }
      }
    });
    $("#select-all").click(function () {
      $("#standard").prop("checked", true);
      $("#business").prop("checked", true);
      $("#enterprise").prop("checked", true);

      $("#standard-e3").prop("checked", true);
      $("#standard-e5").prop("checked", true);
      $("#business-basic").prop("checked", true);
      $("#business-standard").prop("checked", true);
      $("#business-premium").prop("checked", true);
      $("#enterprise-e3").prop("checked", true);
      $("#enterprise-e5").prop("checked", true);

      $(".column-standard.column-header").attr('colspan', 2);
      $(".column-standard").show();
      $(".column-business.column-header").attr('colspan', 3);
      $(".column-business").show();
      $(".column-enterprise.column-header").attr('colspan', 2);
      $(".column-enterprise").show();
    });
    $("#select-none").click(function () {
      $("#standard").prop("checked", false);
      $("#business").prop("checked", false);
      $("#enterprise").prop("checked", false);

      $("#standard-e3").prop("checked", false);
      $("#standard-e5").prop("checked", false);
      $("#business-basic").prop("checked", false);
      $("#business-standard").prop("checked", false);
      $("#business-premium").prop("checked", false);
      $("#enterprise-e3").prop("checked", false);
      $("#enterprise-e5").prop("checked", false);

      $(".column-standard").hide();
      $(".column-business").hide();
      $(".column-enterprise").hide();
    });
    $(".matrix-toggles").show();
  });

  function uncheckToggle(toggle){
    if ($(toggle).prop("checked") == true) {
      $(toggle).click();
    }
  }
  function checkToggle(toggle){
    if ($(toggle).prop("checked") == false) {
      $(toggle).click();
    }
  }

  function toggleGroup(group){
    if (group == 'standard') {
      if ($("#standard").prop("checked") == false) {
        uncheckToggle("#standard-e3");
        uncheckToggle("#standard-e5");
      } else {
        checkToggle("#standard-e3");
        checkToggle("#standard-e5");
      }
    } else if (group == 'business') {
      if ($("#business").prop("checked") == false) {
        uncheckToggle("#business-basic");
        uncheckToggle("#business-standard");
        uncheckToggle("#business-premium");
      } else {
        checkToggle("#business-basic");
        checkToggle("#business-standard");
        checkToggle("#business-premium");
      }
    } else if (group == 'enterprise') {
      if ($("#enterprise").prop("checked") == false) {
        uncheckToggle("#enterprise-e3");
        uncheckToggle("#enterprise-e5");
      } else {
        checkToggle("#enterprise-e3");
        checkToggle("#enterprise-e5");
      }
    }
  }

  // Get the button that opens the modal
  var btn = document.querySelectorAll(".modal-button");

  // All page modals
  var modals = document.querySelectorAll(".matrix-modal");

  // Get the <span> element that closes the modal
  var spans = document.getElementsByClassName("closeModal");

  // When the user clicks the button, open the modal
  for (var i = 0; i < btn.length; i++) {
    btn[i].onclick = function (e) {
      e.preventDefault();
      modal = document.querySelector(e.target.getAttribute("href"));
      modal.style.display = "block";
      let defaultScrollLeft = (modal.scrollWidth - modal.clientWidth)/2;
      let defaultScrollTop = (modal.scrollHeight - modal.clientHeight)/2;      
      modal.scrollLeft = defaultScrollLeft;
      modal.scrollTop = defaultScrollTop;
    };
  }

  // When the user clicks on <span> (x), close the modal
  for (var i = 0; i < spans.length; i++) {
    spans[i].onclick = function () {
      for (var index in modals) {
        if (typeof modals[index].style !== "undefined")
          modals[index].style.display = "none";
      }
    };
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function (event) {
    if (event.target.classList.contains("matrix-modal")) {
      for (var index in modals) {
        if (typeof modals[index].style !== "undefined")
          modals[index].style.display = "none";
      }
    }
  };